(function () {
  'use strict';

  function initialiseCabjaksFooter() {
    var footer = document.querySelector('.cab-footer');

    if (!footer) {
      return;
    }

    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var columns = footer.querySelectorAll('.cab-footer__column');

    function closeColumn(column) {
      var button = column.querySelector('.cab-footer__accordion-button');

      column.classList.remove('is-open');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    }

    function openColumn(column) {
      var button = column.querySelector('.cab-footer__accordion-button');

      column.classList.add('is-open');

      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }
    }

    function closeAllColumns(exceptColumn) {
      Array.prototype.forEach.call(columns, function (column) {
        if (column !== exceptColumn) {
          closeColumn(column);
        }
      });
    }

    function updateFooterMode() {
      if (mobileQuery.matches) {
        footer.classList.add('cab-footer--ready');

        Array.prototype.forEach.call(columns, function (column) {
          closeColumn(column);
        });
      } else {
        footer.classList.remove('cab-footer--ready');

        Array.prototype.forEach.call(columns, function (column) {
          closeColumn(column);
        });
      }
    }

    footer.addEventListener('click', function (event) {
      var button = event.target.closest('.cab-footer__accordion-button');

      if (!button || !footer.contains(button) || !mobileQuery.matches) {
        return;
      }

      var column = button.closest('.cab-footer__column');

      if (!column) {
        return;
      }

      var isOpen = column.classList.contains('is-open');

      closeAllColumns(column);

      if (isOpen) {
        closeColumn(column);
      } else {
        openColumn(column);
      }
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateFooterMode);
    } else {
      mobileQuery.addListener(updateFooterMode);
    }

    updateFooterMode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCabjaksFooter);
  } else {
    initialiseCabjaksFooter();
  }
})();